// extracted by mini-css-extract-plugin
module.exports = {"logo":"Navbar_logo__2eFXQ","navText":"Navbar_navText__iPazY"};